import React, { useState, useEffect, Fragment } from "react";
import {
  OuterBox,
  LoadingButton,
  SubheaderSection,
  MandatoryNote,
  SelectField,
  CommonTextField,
} from "./../../../components";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Grid, Box } from "@mui/material";

import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { Loader } from "../../../components";
import DocumentUpload from "../DocumentUpload";
import { useAlert, useAxios, useComponent } from "./../../../hooks/";
import { useNavigate } from "react-router-dom";
import pages from "../../../constants/pages";

const MyComponent = () => {
  const [timeOptions, setTimeOptions] = useState([]);
  const navigate = useNavigate();
  const [departmentOptions, setDepartmentOptions] = useState([]);

  const { loader } = useComponent();

  const [officeOptions, setOfficeOptions] = useState([]);

  const [officerOptions, setOfficerOptions] = useState([]);

  // const [department, setDepartment] = useState([]);
  // const [documentFile, setDocumentFile] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false);

  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [dateOptions, setDateOptions] = useState([]);

  const shouldDisableDate = (date) => {
    return !dateOptions.some((dateOption) => {
      const optionDate = new Date(dateOption.dates);
      return (
        optionDate.getDate() === date.getDate() &&
        optionDate.getMonth() === date.getMonth() &&
        optionDate.getFullYear() === date.getFullYear()
      );
    });
  };

  const fetchDates = async (selectedOfficer) => {
    try {
      const response = await axios({
        url: `/admin/slots/dates?officer_id=${selectedOfficer}`,
        method: "GET",
      });

      if (response.status && response.data.length > 0) {
        const dates = response.data;
        setDateOptions(dates);
      } else {
        dispatch(
          alert({
            type: "error",
            message: "Booking dates not available",
          })
        );
      }
    } catch (error) {
      console.error("Error in fetching available dates", error);
    }
  };

  const handleOfficerChange = (event) => {
    setDateOptions([]);
    setTimeOptions([]);
    const selectedOfficer = event.target.value;
    formik.setFieldValue("officer", selectedOfficer);
    formik.setFieldValue("date", null);
    formik.setFieldValue("time", "");

    // Fetch available dates based on the selected officer
    fetchDates(selectedOfficer);
  };

  useEffect(() => {
    loader.start(2);
    axios({
      url: "/admin/appointments/states",
      method: "GET",
    })
      .then((response) => {
        if (response.status) {
          setStateOptions(response.data);
        }
        loader.apiComplete();
      })
      .catch((error) => {
        console.error("Error in fetching states list", error);
      });
    axios({
      url: `/admin/departments`,
      method: "GET",
    })
      .then((response) => {
        if (response.status) {
          setDepartmentOptions(response.data);
        }
        loader.apiComplete();
      })
      .catch((error) => {
        console.error("Error in fetching deparment list", error);
      });
  }, [loader, axios]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const regex = /^[A-Za-z\s]*$/;

    if (regex.test(inputValue)) {
      formik.handleChange(e);
    }
  };

  // const handleGoBack = () => {
  //   navigate(-1);
  // };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email format")
      .matches(
        /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
        "Invalid email format"
      )
      .required("Email is required"),
    department: Yup.string().required("Department is required"),
    PurposeVisit: Yup.string().required("Purpose of Visit is required"),

    office: Yup.string().required("Office is required"),
    officer: Yup.string().required("Officer is required"),
    date: Yup.date()
      .test("valid-date", "Invalid date", (value) => {
        // Check if the selected date is one of the available dates
        return dateOptions.some((dateOption) => {
          const optionDate = new Date(dateOption.dates);
          return (
            optionDate.getDate() === value.getDate() &&
            optionDate.getMonth() === value.getMonth() &&
            optionDate.getFullYear() === value.getFullYear()
          );
        });
      })
      .required("Date is required"),
    time: Yup.string().required("Time is required"),
    reason: Yup.string().when("PurposeVisit", {
      is: (purpose) => purpose === "other",
      then: Yup.string().required("Reason is required"),
      otherwise: Yup.string("Official", "Personal"),
    }),
    state: Yup.string().required("State is required"),
    district: Yup.string().required("District is required"),
    organization: Yup.string(),
    designation: Yup.string(),
    documentFile: Yup.mixed().notRequired(),
  });

  // const handleFileChange = async (event) => {
  //   try {
  //     const file = event.target.files[0];

  //     if (!file) {
  //       return;
  //     }
  //     event.target.value = null;
  //     if (file.size > 2 * 1024 * 1024) {
  //       dispatch(
  //         alert({
  //           type: "error",
  //           message: "File size exceeds 2MB. Please choose a smaller file.",
  //         })
  //       );
  //       return;
  //     }

  //     setUploadLoading(true);

  //     const Location = await AwsUpload(file);
  //     setUploadLoading(false);
  //     if (Location) {
  //       const fileName =
  //         file.name.length > 20 ? `${file.name.slice(0, 20)}...` : file.name;
  //       setDocumentFileName(fileName);

  //       formik.setFieldValue("documentFile", Location); // Use setFieldValue directly

  //       dispatch(
  //         alert({
  //           type: "success",
  //           message: "File Upload Successful",
  //         })
  //       );
  //     } else {
  //       dispatch(
  //         alert({
  //           type: "error",
  //           message: "Error in uploading file ",
  //         })
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error uploading file to S3", error);
  //   }
  // };

  const handleDepartmentChange = async (event) => {
    setOfficeOptions([]);
    setOfficerOptions([]);
    setDateOptions([]);
    setTimeOptions([]);
    const selectedDepartment = event.target.value;
    formik.setFieldValue("department", selectedDepartment);
    formik.setFieldValue("office", "");
    formik.setFieldValue("officer", "");
    formik.setFieldValue("date", null);
    formik.setFieldValue("time", "");

    try {
      const response = await axios({
        url: `/admin/offices?dept_id=${selectedDepartment}`,
        method: "GET",
      });
      if (response.status) {
        setOfficeOptions(response.data);
      }
    } catch (error) {
      console.error("Error in fetching office list", error);
    }
  };

  const handleOfficeChange = (event) => {
    setOfficerOptions([]);
    setDateOptions([]);
    setTimeOptions([]);
    const selectedOffice = event.target.value;
    formik.setFieldValue("office", selectedOffice);
    formik.setFieldValue("officer", "");
    formik.setFieldValue("date", null);
    formik.setFieldValue("time", "");

    fetchOfficers(formik.values.department, selectedOffice);
  };

  const fetchOfficers = async (selectedDepartment, selectedOffice) => {
    try {
      const response = await axios({
        url: `/admin/offices/officers?dept_id=${selectedDepartment}&office_id=${selectedOffice}`,
        method: "GET",
      });
      if (response.status) {
        setOfficerOptions(response.data);
      }
    } catch (error) {
      console.error("Error in fetching officer list", error);
    }
  };

  const onSubmit = async (values) => {
    try {
      setLoading(true);
      const requestData = {
        visitor_id: sessionStorage.getItem("visitorId"),
        dept_id: values.department,
        officer_id: values.officer,
        email_id: values.email,
        purpose: values.reason,

        slot_id: values.time,
        office_id: values.office,
        state_id: values.state,
        district_id: values.district,
      };

      if (values.reason) {
        requestData.purpose = values.PurposeVisit + ":" + values.reason;
      } else {
        requestData.purpose = values.PurposeVisit;
      }

      if (values.documentFile) {
        requestData.visitor_card = values.documentFile;
      }

      if (values.designation) {
        requestData.designation = values.designation;
      }

      if (values.organization) {
        requestData.organization_name = values.organization;
      }

      const response = await axios({
        url: "/booking/appointment/book-appointment",
        method: "POST",
        data: requestData,
      });

      if (response.status) {
        setLoading(false);
        if (!response.data.id) {
          dispatch(
            alert({
              type: "error",
              message: response.message.displayMessage,
            })
          );
        } else {
          dispatch(
            alert({
              type: "success",
              message: response.message.displayMessage,
            })
          );

          sessionStorage.setItem("ref_id", response.data.ref_id);
          sessionStorage.setItem("id", response.data.id);
          navigate(pages.AppointmentBookingDetail.route, {
            state: {
              details: response.data,
            },
          });
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Error in Appointment booking", error);
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      department: "",
      office: "",
      officer: "",
      date: null,
      time: "",
      state: "",
      district: "",
      reason: "",
      organization: "",
      designation: "",
      documentFile: null,
      PurposeVisit: "",
    },
    validationSchema,
    onSubmit,
  });

  // Function to fetch districts based on the selected state
  const fetchDistricts = async (selectedState) => {
    try {
      const response = await axios({
        url: `/admin/appointments/districts?state_id=${selectedState}`,
        method: "GET",
      });
      if (response.status) {
        setDistrictOptions(response.data);
      }
    } catch (error) {
      console.error("Error in fetching district list", error);
    }
  };

  // Function to handle state selection change
  const handleStateChange = (event) => {
    setDistrictOptions([]);
    const selectedState = event.target.value;
    formik.setFieldValue("state", selectedState);
    formik.setFieldValue("district", ""); // Reset selected district when state changes
    fetchDistricts(selectedState);
  };

  const handleDateChange = (newValue) => {
    formik.setFieldValue("time", "");
    setTimeOptions([]);

    formik.setFieldValue("date", newValue);
    // if (!formik.errors.date) {
    if (newValue instanceof Date && !isNaN(newValue)) {
      const isValidDate = dateOptions.some((dateOption) => {
        const optionDate = new Date(dateOption.dates);
        return (
          optionDate.getDate() === newValue.getDate() &&
          optionDate.getMonth() === newValue.getMonth() &&
          optionDate.getFullYear() === newValue.getFullYear()
        );
      });

      if (isValidDate) {
        const formattedDate = `${newValue.getFullYear()}-${
          newValue.getMonth() + 1
        }-${newValue.getDate()}`;

        fetchTimeSlots(formattedDate);
      } else {
        console.error("Selected date is not valid");
      }
    }
  };

  const fetchTimeSlots = async (selectedDate) => {
    try {
      const response = await axios({
        url: `/admin/slots?officer_id=${formik.values.officer}&date=${selectedDate}`,
        method: "GET",
      });
      if (response.status && response.data.length > 0) {
        setTimeOptions(response.data);
      } else {
        dispatch(
          alert({
            type: "error",
            message: "Slots not available",
          })
        );
      }
    } catch (error) {
      console.error("Error in fetching time slots", error);
    }
  };

  return (
    <Loader>
      <OuterBox>
        <SubheaderSection
          textAlign="left"
          title="Book Appointment"
          content="Please provide the following details to book your appointment"
        />

        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={2} sx={{ textTransform: "capitalize" }}>
            <SelectField
              label="Select Premises"
              name="department"
              value={formik.values.department}
              options={departmentOptions.map((department) => ({
                id: department.id,
                name: department.name,
              }))}
              onChange={handleDepartmentChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.department && Boolean(formik.errors.department)
              }
            />

            <SelectField
              label="Select Department"
              name="office"
              value={formik.values.office}
              options={officeOptions.map((office) => ({
                id: office.id,
                name: office.name,
              }))}
              onChange={handleOfficeChange}
              onBlur={formik.handleBlur}
              error={formik.touched.office && Boolean(formik.errors.office)}
              disabled={officeOptions.length === 0}
            />

            <SelectField
              label="Select Officer"
              name="officer"
              value={formik.values.officer}
              options={officerOptions.map((officer) => ({
                id: officer.id,
                name: officer.name,
              }))}
              onChange={handleOfficerChange}
              onBlur={formik.handleBlur}
              error={formik.touched.officer && Boolean(formik.errors.officer)}
              disabled={officerOptions.length === 0}
            />

            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <FormControl fullWidth variant="outlined">
                  <DatePicker
                    label={
                      <>
                        Select Date
                        <span
                          style={{
                            color: "red",
                            float: "right",
                            paddingLeft: "5px",
                          }}
                        >
                          *
                        </span>
                      </>
                    }
                    autoComplete="off"
                    placeholder="Select Date"
                    value={formik.values.date}
                    onBlur={formik.handleBlur}
                    error={formik.touched.date && Boolean(formik.errors.date)}
                    onChange={handleDateChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name={"date"}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.date && Boolean(formik.errors.date)
                        }
                        value={formik.values.date}

                        // InputProps={{
                        //   readOnly: true, // Disable manual input
                        // }}
                      />
                    )}
                    shouldDisableDate={shouldDisableDate}
                    disabled={dateOptions.length === 0}
                    inputFormat="dd/MM/yyyy" // Set the desired date format here
                  />
                </FormControl>
              </LocalizationProvider>
            </Grid>

            <SelectField
              label="Select Time Slot"
              name="time"
              value={formik.values.time}
              options={timeOptions.map((time) => ({
                id: time.id,
                name: time.slots,
              }))}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.time && Boolean(formik.errors.time)}
              disabled={timeOptions.length === 0}
            />

            <SelectField
              label="Purpose of visit"
              name="PurposeVisit"
              value={formik.values.PurposeVisit}
              options={[
                { id: "official", name: "Official" },
                { id: "personal", name: "Personal" },
                { id: "other", name: "Other" },
              ]}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.PurposeVisit &&
                Boolean(formik.errors.PurposeVisit)
              }
            />

            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                variant="outlined"
                label={
                  <Fragment>
                    Please fill in the reason for your appointment
                    {formik.values.PurposeVisit === "other" && (
                      <span
                        style={{
                          color: "red",
                          float: "right",
                          paddingLeft: "5px",
                        }}
                      >
                        *
                      </span>
                    )}
                  </Fragment>
                }
                placeholder="Please fill in the reason for your appointment"
                name="reason"
                value={formik.values.reason}
                onChange={(event) => {
                  if (event.target.value.length <= 250) {
                    // Check character limit
                    formik.handleChange(event);
                  }
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.reason && Boolean(formik.errors.reason)}
                multiline={true}
                rows={6}
                helperText={`${formik.values.reason.length} / 250 characters`}
              />
            </Grid>
          </Grid>

          <Box sx={{ display: "flex", alignItems: "left", my: "16px" }}>
            <SubheaderSection
              textAlign="left"
              title="Personal Details"
              variant="h3"
            />
          </Box>

          <Grid container spacing={2} sx={{ textTransform: "capitalize" }}>
            <CommonTextField
              label="Enter Your Email"
              placeholder="Enter Your Email"
              name="email"
              type="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              required
            />

            <SelectField
              label="Choose Your State"
              name="state"
              value={formik.values.state}
              options={stateOptions.map((state) => ({
                id: state.state_id,
                name: state.state_name,
              }))}
              onChange={handleStateChange}
              onBlur={formik.handleBlur}
              error={formik.touched.state && Boolean(formik.errors.state)}
            />

            <SelectField
              label="Choose Your District"
              name="district"
              value={formik.values.district}
              options={districtOptions.map((district) => ({
                id: district.district_id,
                name: district.district_name,
              }))}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.district && Boolean(formik.errors.district)}
              disabled={districtOptions.length === 0}
            />

            <CommonTextField
              label="Enter Your organization's Name (Optional)"
              placeholder="Enter Your organization's Name (Optional)"
              name="organization"
              value={formik.values.organization}
              onChange={handleInputChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.organization &&
                Boolean(formik.errors.organization)
              }
            />
            <CommonTextField
              label="Enter Your Designation (Optional)"
              placeholder="Enter Your Designation (Optional)"
              name="designation"
              value={formik.values.designation}
              onChange={handleInputChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.designation && Boolean(formik.errors.designation)
              }
            />
          </Grid>
          <Grid container spacing={2} sx={{ textTransform: "capitalize" }}>
            <DocumentUpload
              setUploadLoading={setUploadLoading}
              uploadLoading={uploadLoading}
              formik={formik}
            />
          </Grid>

          <LoadingButton
            loading={loading}
            onClick={formik.handleSubmit}
            disabled={uploadLoading}
          >
            Request Appointment
          </LoadingButton>
          <MandatoryNote />
        </form>
      </OuterBox>
    </Loader>
  );
};

export default MyComponent;
